module.exports = __webpack_public_path__ + "img/volume-down-fill.930729ec.svg";